import { useGetStateByStateKey } from '../../../../api/lending/lapiHooks';

export function useSellerName() {
  const { state: customerState } = useGetStateByStateKey();
  const sellerName =
    customerState?.application?.company?.registered_company_name;

  return sellerName;
}
